import { apiClient } from './client'

export interface Notification {
  id: string
  type: string
  title: string
  body?: string | null
  link?: string | null
  ref_id?: string | null
  is_read: boolean
  read_at?: string | null
  created_at: string
}
export interface NotificationList {
  items: Notification[]
  unread: number
}

export async function listNotifications(): Promise<NotificationList> {
  const res = await apiClient.get<NotificationList>('/notifications')
  return res.data
}
export async function markRead(id: string): Promise<void> {
  await apiClient.post(`/notifications/${id}/read`)
}
export async function markAllRead(): Promise<void> {
  await apiClient.post('/notifications/read-all')
}

export interface BroadcastResult {
  id: string
  recipients: number
  channel_posted: boolean
}
export async function sendNotification(data: {
  title: string
  body?: string
  channel_id?: string
}): Promise<BroadcastResult> {
  const res = await apiClient.post<BroadcastResult>('/notifications/send', data)
  return res.data
}

export interface BroadcastSummary {
  id: string
  title: string
  body?: string | null
  recipients: number
  channel_posted: boolean
  created_at: string
}
export async function listBroadcasts(): Promise<BroadcastSummary[]> {
  const res = await apiClient.get<{ items: BroadcastSummary[] }>('/notifications/broadcasts')
  return res.data.items
}
export async function deleteBroadcast(id: string): Promise<void> {
  await apiClient.delete(`/notifications/broadcasts/${id}`)
}
